'use strict';

/**
 * Check if element is in view port
 *
 * @TODO upgrade to Intersection Observer API for better performance
 *      https://webdesign.tutsplus.com/tutorials/how-to-intersection-observer--cms-30250
 *      https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
 *
 * @param el
 * @returns {boolean}
 */
export default function (el) {
    let r, html;
    if (!el || 1 !== el.nodeType) {
        return false;
    }
    html = document.documentElement;
    r = el.getBoundingClientRect();

    return (
        !!r &&
        r.bottom >= 0 &&
        r.right >= 0 &&
        r.top <= html.clientHeight &&
        r.left <= html.clientWidth
    );
}

/**
 * Check if element is completely in view port
 *
 * @param {element} element
 * @returns {boolean}
 */

export function isElementOnScreen(element) {
    if (!element) return;
    const elementRect = element.getBoundingClientRect();
    const { top: elementTop, bottom: elementBottom } = elementRect;

    const isVisible = elementTop >= 0 && elementBottom <= window.innerHeight;
    return isVisible;
}
